module.exports = __webpack_public_path__ + "img/Timely-technical-support.8af7452a.png";